import { LogManager } from '../../../common/port/log/log.manager.port';
import { SelfChallengeTargetStreakMapper } from '../../../infrastructure/mappers/challenge-target-result/self-challenge-target-streak.mapper';
import { GetSelfMetricsInsightsChallengeTargetStreakRequestDto } from '../../dtos/challenge-insights/get-self-metrics-insights-challenge-target-sreak.request.dto';
import { GetSelfMetricsInsightsChallengeTargetStreakResponseDto } from '../../dtos/challenge-insights/get-self-metrics-insights-challenge-target-sreak.response.dto';
import { GetSelfMetricsInsightsChallengeTargetStreakQuery } from '../../queries/challenge-insights/get-self-metrics-insights-challenge-target-streak.query';

export class GetSelfMetricsInsightsChallengeTargetStreakController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetSelfMetricsInsightsChallengeTargetStreakQuery,
    protected readonly mapper: SelfChallengeTargetStreakMapper
  ) {}

  async get(
    props: GetSelfMetricsInsightsChallengeTargetStreakRequestDto
  ): Promise<GetSelfMetricsInsightsChallengeTargetStreakResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetSelfMetricsInsightsChallengeTargetStreakController.get encountered an error ${error}`
      );
    }
  }
}
